import React from 'react';
import { useEpgDataFilteredForNow, } from '@24i/nxg-sdk-smartott/src/screens/PlaybackScreen/managers';
import { useDimensions } from '@24i/nxg-sdk-quantum';
import { Breakpoint } from '@24i/nxg-sdk-smartott/src/utils/styles/constants';
import { modalType, usePlayerUIContext } from '@24i/player-ui';
import { SeekRelativeButton, Sign } from '../../../../SeekRelativeButton';
import { PrevNextChannelButton, Type } from '../../../../PrevNextChannelButton';
import { PlayPauseButton } from '../../../../PlayPauseButton';
import { UnlockButton } from './components/UnlockButton';
import { Container, CenteredMobileViewContainer, BlockingMessage, buttonStyles as getStyles, middleButtonStyles, } from './styled';
export const PlayerControls = ({ playerInstance, epgData, blockingReason, onUnlockAction, onPlayPausePress, }) => {
    const { width, height, isLandscape } = useDimensions();
    const { state } = usePlayerUIContext();
    const styles = getStyles(isLandscape);
    const nowFilter = useEpgDataFilteredForNow();
    const filteredPrograms = nowFilter(epgData);
    const hasEpgData = Boolean(epgData && (filteredPrograms === null || filteredPrograms === void 0 ? void 0 : filteredPrograms.length) > 1);
    const shouldShowPrevNextChannelButtons = hasEpgData && epgData.channels.length > 1;
    const shouldShowSeekButtons = playerInstance && !shouldShowPrevNextChannelButtons && !blockingReason;
    const isMobile = width <= Breakpoint.MD || height <= Breakpoint.MD;
    const isOpen = state[modalType.episodes].isOpen || state[modalType.channels].isOpen;
    return (React.createElement(Container, { shouldBeHidden: isOpen }, isMobile && (React.createElement(React.Fragment, null,
        React.createElement(CenteredMobileViewContainer, null,
            shouldShowSeekButtons && (React.createElement(SeekRelativeButton, { playerInstance, styles, sign: Sign.Negative })),
            shouldShowPrevNextChannelButtons && (React.createElement(PrevNextChannelButton, { epgData, styles, type: Type.Previous })),
            blockingReason ? (React.createElement(UnlockButton, { blockingReason, onUnlockAction, styles: { icon: middleButtonStyles.icon } })) : (React.createElement(PlayPauseButton, { playerInstance,
                styles: middleButtonStyles,
                onPlayPausePress })),
            shouldShowSeekButtons && (React.createElement(SeekRelativeButton, { playerInstance, styles, sign: Sign.Positive })),
            shouldShowPrevNextChannelButtons && (React.createElement(PrevNextChannelButton, { epgData, styles, type: Type.Next }))),
        blockingReason && React.createElement(BlockingMessage, { blockingReason })))));
};
//# sourceMappingURL=index.js.map